export function scopeId() {

    return {
        restrict: 'A',
        replace: false,
        link: function ($scope, elem, attrs) {

            $scope[attrs.scopeId] = elem[0];

            return $scope;
        }
    };
}


// WEBPACK FOOTER //
// ./src/ui/directives/scope-id.directive.js